import {
  DynamicColumn,
  ForeignKeyField,
  RemoteDataSource,
  Required,
  Schema,
  TextField
} from "lego-gui-lib";
import { t } from "../../core/i18n/i18n";
import { api, mainStore } from "../../core/mainStore";
import { Auth } from "../../core/model/auth";

export const BarringMatrixSchema = new Schema<DynamicColumn>({
  fields: [
    {
      name: "name",
      title: t("common:name"),
      type: TextField(Required)
    }
  ],
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANY_ADMIN,
    editableRole: Auth.Roles.ADMIN
  }
});

export const BarringMatrixSchemaForm = BarringMatrixSchema.extend({
  id: false
});

mainStore.barringMatrix = RemoteDataSource.create({
  api: api,
  name: "barringMatrix",
  schema: BarringMatrixSchema,
  url: "/barringMatrixes",
  commons: mainStore.commons
});

mainStore.barringMatrixFk = RemoteDataSource.clone(mainStore.barringMatrix);

export const BarringMatrixFK = ForeignKeyField(
  {
    dataSource: mainStore.barringMatrixFk.listDataSource,
    labelField: "name",
    valueField: "id",
    minWidth: 70
  },
  Required
);

export const BarringMatrixFKNotRequired = ForeignKeyField({
  dataSource: mainStore.barringMatrixFk.listDataSource,
  labelField: "name",
  valueField: "id",
  minWidth: 70
});
